"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var GameController = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_GameController_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 2,
    width: 18,
    height: 12
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 7a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM6 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 5.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM10.25 7.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM12.25 8.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM12.75 7.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.298 2.5a3.277 3.277 0 0 0-3.22 2.664L.014 10.752a2.736 2.736 0 0 0 5.064 1.87l1.08-1.891a.458.458 0 0 1 .398-.231h2.888c.164 0 .316.088.397.23l1.08 1.891a2.736 2.736 0 0 0 5.064-1.87l-1.064-5.587A3.277 3.277 0 0 0 11.7 2.5H4.298ZM2.06 5.351A2.277 2.277 0 0 1 4.298 3.5H11.7c1.094 0 2.033.777 2.237 1.851l1.065 5.588a1.736 1.736 0 0 1-3.213 1.186l-1.08-1.89A1.458 1.458 0 0 0 9.444 9.5H6.556c-.524 0-1.007.28-1.266.735l-1.08 1.89A1.736 1.736 0 0 1 .995 10.94l1.065-5.588Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_GameController_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = GameController;
exports["default"] = _default;